import { appDataReducerPaginationAndSearch } from './reducerMetadata';

// Overview of all applications of an administration
export function appDataReducerApplications(state, action) {
    // Set metadata for the overview
    const meta = appDataReducerPaginationAndSearch(action.applications.message.meta);

    // Set the items for in the overview
    const applications = action.applications.message.data.map((application) => ({
        id: application.id,
        isInternal: application.is_internal,
        type: application.type,
        name: application.name,
        status: application.status,
        accessType: application.access_type,
        websiteId: application.website_id,
        applicationInternalCode: application.application_internal_code,
    }));

    return {
        meta,
        items: applications,
    };
}

// Detail of one application
export function appDataReducerApplication(state, action) {
    const applicationDetail = action.application.message.data;

    return {
        id: applicationDetail.id,
        isInternal: applicationDetail.is_internal,
        type: applicationDetail.type,
        name: applicationDetail.name,
        status: applicationDetail.status,
        accessType: applicationDetail.access_type,
        websiteId: applicationDetail.website_id,
        applicationInternalCode: applicationDetail.application_internal_code,
    };
}
